<script setup lang="ts">
import { computed } from "vue";
import { useRoute, RouterView } from "vue-router";
import AppShell from "@/components/AppShell.vue";

const route = useRoute();
const isPublic = computed(() => route.meta.public === true);
</script>

<template>
  <RouterView v-if="isPublic" />
  <AppShell v-else>
    <RouterView />
  </AppShell>
</template>
